// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"c458ab1eddb0da262c1a","655":"d7186bd247eb379f4664"}[chunkId] + ".js";
};